export class ResetPasswordModel {
  public password: string;
  public confirmPassword: string;
  public forgotEmailToken: string;
  public languageId: number;
}
